import { cyrillicToLatin } from "./transliterate"

/**
 * Converts a string to a URL-friendly slug
 * - Transliterates Cyrillic to Latin characters
 * - Converts to lowercase
 * - Replaces spaces and special characters with hyphens
 * - Removes duplicate hyphens
 */
export function slugify(text: string): string {
  return cyrillicToLatin(text)
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/[^\w-]+/g, "") // Remove all non-word chars
    .replace(/--+/g, "-") // Replace multiple hyphens with single hyphen
    .replace(/^-+/, "") // Trim hyphens from start
    .replace(/-+$/, "") // Trim hyphens from end
}

/**
 * Builds a full URL path for a category
 * @param basePath - The base path (e.g., '/kucheta/hrana')
 * @param categoryName - The category name to slugify
 */
export function buildCategoryUrl(basePath: string, categoryName: string): string {
  const slug = slugify(categoryName)
  return `${basePath}/${slug}`
}

